module.exports = __webpack_public_path__ + "static/img/cgal8.1583ab3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal8.png
// module id = Wuo0
// module chunks = 1